const normalizeRole = (role) =>
  String(role?.name ?? role?.role ?? role ?? "")
    .trim()
    .toLowerCase();

export function getStoredRoles() {
  const raw = localStorage.getItem("userRoles") || "";

  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed.map(normalizeRole).filter(Boolean);
    if (parsed && typeof parsed === "object") {
      const roles = parsed.roles || parsed.userRoles || [];
      return (Array.isArray(roles) ? roles : [roles])
        .map(normalizeRole)
        .filter(Boolean);
    }
    return [normalizeRole(parsed)].filter(Boolean);
  } catch {
    return raw
      .replaceAll("[", "")
      .replaceAll("]", "")
      .replaceAll('"', "")
      .split(/[;,]/)
      .map(normalizeRole)
      .filter(Boolean);
  }
}

export const isSuperAdminUser = () =>
  getStoredRoles().includes("superadmin");
